import { useMapContext } from 'components/MapV2/MapProvider'
import { GEOCODE_API } from 'components/MapV2/constants'
import { mirrorFetch } from 'components/MapV2/utils'
import { LatLngTuple } from 'leaflet'
import React from 'react'
import { useMapEvents } from 'react-leaflet'

export const MapEvents: React.FC = () => {
  const { onMapClick, setAddress, shouldGetAddressOnClick } = useMapContext()
  const map = useMapEvents({
    dragend: () => {
      map.invalidateSize()
    },
    zoomend: () => {
      map.invalidateSize()
    },
    resize: () => {
      map.invalidateSize()
    },
    click(e) {
      onMapClick?.([e.latlng.lat, e.latlng.lng] as LatLngTuple)
      if (shouldGetAddressOnClick && setAddress) {
        mirrorFetch(`${GEOCODE_API}latlng=${e.latlng.lat},${e.latlng.lng}`).then((res) => {
          const formattedAddress = res?.results?.[0]?.formatted_address
          formattedAddress && setAddress(formattedAddress)
        })
      }
    },
  })

  return null
}
